import { ISelectorOption, Undefinable } from 'providence-types';

export const findFromSelectorOptions = <T = string>(
  findValue: T,
  selectorOptions: ISelectorOption<T>[],
): Undefinable<T> =>
  selectorOptions.find(({ value }: ISelectorOption<T>) => value === findValue)
    ?.viewValue;
